import { useEffect } from 'react';
import { notifyProductCountChange } from '../../utils/collectionProductDataHelpers';
import type { FilterSummary } from '../../types/filters';

interface ApiResponseData {
  total?: number;
  summary?: FilterSummary;
}

/**
 * Shared hook for common product grid side effects
 * Used by both useProductGridData and useSearchProductGridData
 */
export const useProductGridEffects = ({
  data,
  onProductCountChange,
  onFilterSummaryChange,
}: {
  data: ApiResponseData;
  onProductCountChange?: (count: number) => void;
  onFilterSummaryChange?: (summary: FilterSummary | undefined) => void;
}) => {
  // Notify parent component of product count changes
  useEffect(() => {
    notifyProductCountChange(data, onProductCountChange);
  }, [data, onProductCountChange]);

  // Handle filter summary updates
  useEffect(() => {
    if (onFilterSummaryChange) {
      if (data?.summary) {
        onFilterSummaryChange(data.summary);
      } else {
        onFilterSummaryChange(undefined);
      }
    }
  }, [data, data?.summary, onFilterSummaryChange]);
};
